// extracted by mini-css-extract-plugin
export var active = "_9n-7";
export var container = "_9n-0";
export var evenWidth = "_9n-4";
export var large = "_9n-5";
export var outlet = "_9n-8";
export var slide = "_9n-2";
export var small = "_9n-6";
export var tab = "_9n-3";
export var tabs = "_9n-1";